import RuleModal from '@/components/business/games/rule';
import React from 'react';
import {forwardRef, useImperativeHandle, useState} from 'react';
import {useTranslation} from 'react-i18next';

export interface ModalRef {
  open: () => void;
}

const SpinActualRules = forwardRef<ModalRef>((_, ref) => {
  const [visible, setVisible] = useState(false);
  const {t} = useTranslation();

  useImperativeHandle(ref, () => ({
    open: () => setVisible(true),
  }));

  return (
    <RuleModal
      visible={visible}
      title={t('promotionsV2.rules')}
      onClose={() => setVisible(false)}>
      <ol className="list-decimal list-outside ml-3 text-xs leading-normal text-t2">
        <li>
          <p>{t('spinActual.tip.rules.p1')}</p>
          <table className="w-full table-fixed align-middle text-center border border-t3 [&_th]:border [&_td]:border [&_th]:border-t3 [&_td]:border-t3 [&_th]:h-8 [&_td]:h-8">
            <thead>
              <th>{t('spinActual.label.prizeLevel')}</th>
              <th>{t('spinActual.label.prizeName')}</th>
            </thead>
            <tbody>
              <tr>
                <td>{t('spinActual.label.prize1')}</td>
                <td>iPhone 16 PRO</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize2')}</td>
                <td>One Plus 13R</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize3')}</td>
                <td>1 Gram Gold Coin</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize4')}</td>
                <td>OnePlus Buds Pro 3</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize5')}</td>
                <td>SpinX2</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize6')}</td>
                <td>SpinX1</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize7')}</td>
                <td>₹50</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize8')}</td>
                <td>₹20</td>
              </tr>
              <tr>
                <td>{t('spinActual.label.prize9')}</td>
                <td>No Won</td>
              </tr>
            </tbody>
          </table>
        </li>
        <li>{t('spinActual.tip.rules.p2')}</li>
        <li>{t('spinActual.tip.rules.p3')}</li>
        <li>{t('spinActual.tip.rules.p4')}</li>
        <li>{t('spinActual.tip.rules.p5')}</li>
        <li>{t('spinActual.tip.rules.p6')}</li>
        <li>{t('spinActual.tip.rules.p7')}</li>
      </ol>
    </RuleModal>
  );
});

export default SpinActualRules;
